var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 10.083L9.70185 14.1006C9.81117 14.1552 9.86583 14.1826 9.92316 14.1933C9.97394 14.2028 10.026 14.2028 10.0768 14.1933C10.1342 14.1826 10.1888 14.1552 10.2981 14.1006L18.3333 10.083M1.66666 5.91631L9.70185 1.89872C9.81117 1.84406 9.86583 1.81673 9.92316 1.80597C9.97394 1.79645 10.026 1.79645 10.0768 1.80597C10.1342 1.81673 10.1888 1.84406 10.2981 1.89872L18.3333 5.91631L10.2981 9.93391C10.1888 9.98857 10.1342 10.0159 10.0768 10.0267C10.026 10.0362 9.97394 10.0362 9.92316 10.0267C9.86583 10.0159 9.81117 9.98857 9.70185 9.93391L1.66666 5.91631Z",
    stroke: "#4D506B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsStack);
export default __webpack_public_path__ + "static/media/projects-stack.6348846d69d509ede108426d29e92acd.svg";
export { ForwardRef as ReactComponent };